import queries from '@/services/links_queries.js';

export default [
  { id:'icon-geoportal', href: queries.idea, src: require('./images/geoportal.png'), srcHover: require('./images/geoportal_hover.png') },
  { id:'icon-inicio', href: queries.inicio, src: require('./images/inicio.svg'), srcHover: require('./images/inicio_hover.svg') },
  { id:'icon-metereologico', href: queries.reporte_metereologico, src: require('./images/meteorologico.svg'), srcHover: require('./images/meteorologico_hover.svg') },
  { id:'icon-cdiac', href: queries.cdiac, src: require('./images/cdiac.svg'), srcHover: require('./images/cdiac_hover.svg') },
  { id:'icon-facebook', href: queries.facebook, src: require('./images/facebook.svg'), srcHover:require('./images/facebook_hover.svg') },
  { id:'icon-twitter', href: queries.twitter, src: require('./images/twitter.svg'), srcHover:require('./images/twitter_hover.svg') },
  { id:'icon-correo', href: queries.email, src: require('./images/correo.svg'), srcHover:require('./images/correo_hover.svg') }
]
